import { render, staticRenderFns } from "./ScrollOnTop.vue?vue&type=template&id=2a4a7ab6&scoped=true&"
import script from "./ScrollOnTop.vue?vue&type=script&lang=js&"
export * from "./ScrollOnTop.vue?vue&type=script&lang=js&"
import style0 from "./ScrollOnTop.vue?vue&type=style&index=0&id=2a4a7ab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4a7ab6",
  null
  
)

export default component.exports